import { useState, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value?: string | null;
  className?: string;
  stopPropagation?: boolean;
};

const CopyButton = ({
  value,
  className = "",
  stopPropagation = true,
}: Props) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const text = String(value ?? "").trim();

  if (!text || text === "-" || text === "—") return null;

  const handleCopy = async (e: MouseEvent) => {
    if (stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  };

  return (
    <button
      type="button"
      title={copied ? t("common.copied") : t("common.copy")}
      aria-label={t("common.copy")}
      onClick={handleCopy}
      className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded text-gray-500 hover:bg-gray-100 hover:text-green transition-colors ${className}`}
    >
      {copied ? (
        <img src="/icons/check.svg" alt="" className="h-3.5 w-3.5" />
      ) : (
        <img src="/icons/copy.svg" alt="" className="h-3.5 w-3.5" />
      )}
    </button>
  );
};

export default CopyButton;
